import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface Props {
  isToastOpen: any;
  message: any;
  setIsToastOpen?: any;
  type: any;
  position: any;
  duration: any;
  onClose : (...arg:any) => void
}

export default function Toast(props: Props) {
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        className={`md:mb-[0px] mb-[0]`}
        open={props?.isToastOpen}
        onClose={() => props.onClose()}
        autoHideDuration={props.duration}
        anchorOrigin={{ vertical: props.position?.vertical || 'bottom', horizontal: props.position?.horizontal || 'center' }}
      >
        <Alert severity={props.type} >
          {props.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
